import { useContext } from 'react';

import { LoanActionsControlsContext } from './constants';

const useLoanActionsControlsContext = () => {
  const value = useContext(LoanActionsControlsContext);

  if (value === null) {
    throw new Error(
      'LoanActionsControls slot must be rendered inside <LoanActionsControlsProvider>',
    );
  }

  return value;
};

export { LoanActionsControlsContext };
export default useLoanActionsControlsContext;
